import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-08eb838e")
const _hoisted_1 = {
  key: 0,
  class: "pool-table-mobile mb-[24px]"
}
const _hoisted_2 = { class: "table-title flex justify-between" }
const _hoisted_3 = { class: "flex w-full items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-full justify-end text-right" }, "TVL & APR", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mt-[12px] border w-full" }, null, -1)
const _hoisted_6 = { class: "flex-column mt-[20px]" }
const _hoisted_7 = {
  key: 0,
  class: "mt-[8px] text-left"
}
const _hoisted_8 = {
  key: 1,
  class: "mt-[8px]"
}
const _hoisted_9 = { class: "flex text-right" }
const _hoisted_10 = { class: "flex-column" }
const _hoisted_11 = { class: "tvl" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "APR" }
const _hoisted_14 = {
  key: 0,
  class: "h-4 w-12"
}
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "APR" }
const _hoisted_17 = {
  key: 0,
  class: "h-4 w-12"
}
const _hoisted_18 = { key: 2 }
const _hoisted_19 = {
  key: 1,
  class: "pool-table mb-[40px]"
}
const _hoisted_20 = { class: "table-title mt-[48px] flex w-full" }
const _hoisted_21 = { class: "grid-table" }
const _hoisted_22 = { class: "pool-header" }
const _hoisted_23 = { class: "heading" }
const _hoisted_24 = ["src"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text-right mr-[65px]" }, "APR", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "text-right" }, "Liquidity", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "text-right" }, "Volume (24h)", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "border" }, null, -1)
const _hoisted_29 = { class: "flex w-full items-center" }
const _hoisted_30 = {
  key: 0,
  class: "text-left"
}
const _hoisted_31 = {
  key: 1,
  class: "flex"
}
const _hoisted_32 = { class: "apr flex items-center justify-end" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "daily pt-1" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "flex items-center self-center liq" }
const _hoisted_37 = {
  key: 1,
  class: "w-full text-right"
}
const _hoisted_38 = { class: "flex items-center self-center vol" }
const _hoisted_39 = {
  key: 1,
  class: "w-full text-right"
}
_popScopeId()

import { format } from 'date-fns';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import { ColumnDefinition } from '@/components/_global/BalTable/BalTable.vue';
import BalChipNew from '@/components/chips/BalChipNew.vue';
import { PRETTY_DATE_FORMAT } from '@/components/forms/lock_actions/constants';
import { POOL_MIGRATIONS_MAP } from '@/components/forms/pool_actions/MigrateForm/constants';
import { PoolMigrationType } from '@/components/forms/pool_actions/MigrateForm/types';
import APRTooltip from '@/components/tooltips/APRTooltip/APRTooltip.vue';
import useBreakpoints from '@/composables/useBreakpoints';
import useDarkMode from '@/composables/useDarkMode';
import useFathom from '@/composables/useFathom';
import useNumbers from '@/composables/useNumbers';
import {
  absMaxApr,
  isMigratablePool,
  isStableLike,
  orderedPoolTokens,
  orderedTokenAddresses,
  totalAprLabel,
} from '@/composables/usePool';
import { bnum } from '@/lib/utils';
import { PoolWithShares } from '@/services/pool/types';
import { POOLS } from '@/constants/pools';

import PoolsTableActionsCell from './PoolsTableActionsCell.vue';
import useStake from '@/composables/PolarisFinance/useStake';
import seigniorageAssetBackImg from '@/assets/images/coins/seigniorage-border.svg';
import communityAssetBackImg from '@/assets/images/coins/community-border.svg';
import classicAssetBackImg from '@/assets/images/coins/classic-border.svg';
type Props = {
  data: PoolWithShares[];
  isLoading?: boolean;
  isLoadingMore?: boolean;
  showPoolShares?: boolean;
  noPoolsLabel?: string;
  isPaginated?: boolean;
  selectedTokens?: string[];
  hiddenColumns?: string[];
  showBoost?: boolean;
  columnStates?: Record<string, string>;
  title: String;
  prices: any;
  noApr?: boolean;
  img: String;
  type: String;
};

/**
 * PROPS & EMITS
 */


function setup(__props: {
  data: PoolWithShares[];
  isLoading?: boolean;
  isLoadingMore?: boolean;
  showPoolShares?: boolean;
  noPoolsLabel?: string;
  isPaginated?: boolean;
  selectedTokens?: string[];
  hiddenColumns?: string[];
  showBoost?: boolean;
  columnStates?: Record<string, string>;
  title: String;
  prices: any;
  noApr?: boolean;
  img: String;
  type: String;
}, { emit }) {

const props = __props
const { isMobile, isDesktop } = useBreakpoints();

/**
 * TYPES
 */




/**
 * COMPOSABLES
 */
const { fNum2 } = useNumbers();
const router = useRouter();
const { t } = useI18n();
const { trackGoal, Goals } = useFathom();
const { darkMode } = useDarkMode();
const { upToLargeBreakpoint, upToMediumBreakpoint } = useBreakpoints();

const wideCompositionWidth = computed(() =>
  upToMediumBreakpoint.value ? 450 : undefined
);

/**
 * DATA
 */
const columns = computed<ColumnDefinition<PoolWithShares>[]>(() => [
  {
    name: 'Icons',
    id: 'icons',
    accessor: 'uri',
    Header: 'iconColumnHeader',
    Cell: 'iconColumnCell',
    width: 125,
    noGrow: true,
  },
  {
    name: t('composition'),
    id: 'poolName',
    accessor: 'id',
    Cell: 'poolNameCell',
    width: props.hiddenColumns.length >= 2 ? wideCompositionWidth.value : 350,
  },
  {
    name: t('myBalance'),
    accessor: pool =>
      fNum2(pool.shares, {
        style: 'currency',
        maximumFractionDigits: 0,
        fixedFormat: true,
      }),
    align: 'right',
    id: 'myBalance',
    hidden: !props.showPoolShares,
    sortKey: pool => Number(pool.shares),
    width: 160,
    cellClassName: 'font-numeric',
  },
  {
    name: t('poolValue'),
    accessor: pool =>
      fNum2(pool.totalLiquidity, {
        style: 'currency',
        maximumFractionDigits: 0,
      }),
    align: 'right',
    id: 'poolValue',
    sortKey: pool => {
      const apr = Number(pool.totalLiquidity);
      if (apr === Infinity || isNaN(apr)) return 0;
      return apr;
    },
    width: 150,
    cellClassName: 'font-numeric',
  },
  {
    name: t('volume24h', [t('hourAbbrev')]),
    accessor: pool => pool?.volumeSnapshot || '0',
    align: 'right',
    id: 'poolVolume',
    Cell: 'volumeCell',
    sortKey: pool => {
      const volume = Number(pool?.volumeSnapshot);
      if (volume === Infinity || isNaN(volume)) return 0;
      return volume;
    },
    width: 175,
    cellClassName: 'font-numeric',
  },
  {
    name: t('myBoost'),
    accessor: pool =>
      pool?.boost ? `${bnum(pool?.boost).toFixed(3)}x` : 'N/A',
    align: 'right',
    id: 'myBoost',
    hidden: !props.showBoost,
    sortKey: pool => Number(pool?.boost || '0'),
    width: 150,
    cellClassName: 'font-numeric',
  },
  {
    name: props.showPoolShares ? t('myApr') : t('apr'),
    Cell: 'aprCell',
    accessor: pool => pool?.apr?.total.unstaked || '0',
    align: 'right',
    id: 'poolApr',
    sortKey: pool => {
      let apr = 0;

      if (pool?.apr) {
        apr = Number(absMaxApr(pool.apr, pool.boost));
      }

      return isFinite(apr) ? apr : 0;
    },
    width: 250,
  },
  {
    name: t('expiryDate'),
    Cell: 'lockEndDateCell',
    accessor: 'lockedEndDate',
    align: 'right',
    id: 'lockEndDate',
    width: 150,
  },
  {
    name: t('migrate'),
    Cell: 'migrateCell',
    accessor: 'migrate',
    align: 'center',
    id: 'migrate',
    width: 150,
  },
  {
    name: t('actions'),
    Cell: 'actionsCell',
    accessor: 'actions',
    align: 'center',
    id: 'actions',
    width: 150,
  },
]);

const visibleColumns = computed(() =>
  columns.value.filter(column => !props.hiddenColumns.includes(column.id))
);

/**
 * METHODS
 */
function handleRowClick(pool: PoolWithShares) {
  trackGoal(Goals.ClickPoolsTableRow);
  router.push({ name: 'pool', params: { id: pool.id } });
}

function navigateToPoolMigration(pool: PoolWithShares) {
  router.push({
    name: 'migrate-pool',
    params: {
      from: pool.id,
      to: POOL_MIGRATIONS_MAP[PoolMigrationType.AAVE_BOOSTED_POOL].toPoolId,
    },
    query: { returnRoute: 'home' },
  });
}

function aprLabelFor(pool: PoolWithShares): string {
  const poolAPRs = pool?.apr;
  if (!poolAPRs) return '0';

  return totalAprLabel(poolAPRs, pool.boost);
}

async function yearlyApr(pool: PoolWithShares) {
  const { getPoolApr } = useStake();
  const apr = await getPoolApr(pool.address, pool.id);
  return apr.yearlyAPR;
}

async function dailyApr(pool: PoolWithShares) {
  const { getPoolApr } = useStake();
  const apr = await getPoolApr(pool.address, pool.id);
  return apr.dailyAPR;
}

function lockedUntil(lockEndDate?: number) {
  return lockEndDate ? format(lockEndDate, PRETTY_DATE_FORMAT) : '—';
}

function iconAddresses(pool: PoolWithShares) {
  return POOLS.Metadata[pool.id]?.hasIcon
    ? [pool.address]
    : orderedTokenAddresses(pool);
}

function findCommonElements3(arr1, arr2) {
  for (let el1 of arr1) {
    for (let el2 of arr2) {
      if (el1.toLowerCase() === el2.toLowerCase()) {
        return false;
      }
    }
  }
  return true;
}
function poolAssetBackImage(type:String){
  if(type=='seigniorage')
    return seigniorageAssetBackImg;
  if(type=='classic')
    return classicAssetBackImg;
  if(type=='community')
    return communityAssetBackImg;
}
function selected(pool) {
  let found = true;
  const poolTokens = Object.values(pool.tokensList);
  const selectedTokens = Object.values(props.selectedTokens);

  if (selectedTokens.length == 0) return true;

  return !findCommonElements3(selectedTokens, poolTokens);
}

return (_ctx: any,_cache: any) => {
  const _component_BalAssetSet = _resolveComponent("BalAssetSet")!
  const _component_TokenPills = _resolveComponent("TokenPills")!
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TokenWeightPill = _resolveComponent("TokenWeightPill")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, _toDisplayString(__props.title), 1)
            ]),
            _hoisted_4
          ]),
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (pool, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex w-full items-center",
              key: idx
            }, [
              (selected(pool))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "flex w-full items-center justify-between",
                    to: '/pool/' + pool.id
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_BalAssetSet, {
                          size: 36,
                          addresses: iconAddresses(pool),
                          width: 100
                        }, null, 8, ["addresses"]),
                        (_unref(POOLS).Metadata[pool.id])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(POOLS).Metadata[pool.id].name), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createVNode(_component_TokenPills, {
                                tokens: 
                _unref(orderedPoolTokens)(pool.poolType, pool.address, pool.tokens)
              ,
                                isStablePool: false,
                                selectedTokens: __props.selectedTokens,
                                showWeight: pool['poolType'] != 'Stable'
                              }, null, 8, ["tokens", "selectedTokens", "showWeight"])
                            ]))
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            (!pool?.apr?.total?.unstaked)
                              ? (_openBlock(), _createBlock(_component_BalLoadingBlock, { key: 0 }))
                              : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(fNum2)(pool?.totalLiquidity, {
                      style: 'currency',
                      maximumFractionDigits: 0,
                    }) + ' TVL'), 1))
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            (__props.noApr)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString('0' + '%')))
                              : (
                  !_ctx.aprs ||
                  !_ctx.aprs[pool.address] ||
                  !_ctx.aprs[pool.address]['dailyAPR']
                )
                                ? (_openBlock(), _createBlock(_component_BalLoadingBlock, { key: 1 }))
                                : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.aprs[pool.address]['dailyAPR'] + '%'), 1))
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            (__props.noApr)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString('0' + '%')))
                              : (
                  !_ctx.aprs ||
                  !_ctx.aprs[pool.address] ||
                  !_ctx.aprs[pool.address]['yearlyAPR']
                )
                                ? (_openBlock(), _createBlock(_component_BalLoadingBlock, { key: 1 }))
                                : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.aprs[pool.address]['yearlyAPR'] + '%'), 1))
                          ])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_unref(isDesktop))
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", null, [
                    (__props.img)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          width: "24",
                          height: "14",
                          class: "pool-icon inline-block mr-2",
                          src: __props.img
                        }, null, 8, _hoisted_24))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(__props.title), 1)
                  ])
                ]),
                _hoisted_25,
                _hoisted_26,
                _hoisted_27
              ]),
              _hoisted_28,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (pool, idx) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                  (selected(pool))
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: '/pool/' + pool.id,
                        class: "my-[18px] flex w-full items-center pool-row"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_29, [
                            _createVNode(_component_BalAssetSet, {
                              size: 34,
                              addresses: iconAddresses(pool),
                              width: 100,
                              backImage: poolAssetBackImage(__props.type)
                            }, null, 8, ["addresses", "backImage"]),
                            (_unref(POOLS).Metadata[pool.id])
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_unref(POOLS).Metadata[pool.id].name), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                  _createVNode(_component_TokenPills, {
                                    class: "token-pill",
                                    tokens: 
                    _unref(orderedPoolTokens)(pool.poolType, pool.address, pool.tokens)
                  ,
                                    isStablePool: false,
                                    selectedTokens: __props.selectedTokens,
                                    showWeight: false
                                  }, null, 8, ["tokens", "selectedTokens"]),
                                  _createVNode(_component_TokenWeightPill, {
                                    class: "ml-[12px]",
                                    tokens: _unref(orderedPoolTokens)(pool.poolType, pool.address, pool.tokens),
                                    boosted: pool.boost
                                  }, null, 8, ["tokens", "boosted"])
                                ]))
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            (__props.noApr)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString('0' + '%')))
                              : (
                  !_ctx.aprs ||
                  !_ctx.aprs[pool.address] ||
                  !_ctx.aprs[pool.address]['yearlyAPR']
                )
                                ? (_openBlock(), _createBlock(_component_BalLoadingBlock, { key: 1 }))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createElementVNode("div", null, _toDisplayString(_ctx.aprs[pool.address]['yearlyAPR'] + '%'), 1),
                                    _createElementVNode("div", _hoisted_34, [
                                      (__props.noApr)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString('0' + '%') + " Daily "))
                                        : (
                      !_ctx.aprs ||
                      !_ctx.aprs[pool.address] ||
                      !_ctx.aprs[pool.address]['dailyAPR']
                    )
                                          ? (_openBlock(), _createBlock(_component_BalLoadingBlock, { key: 1 }))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                              _createTextVNode(_toDisplayString(_ctx.aprs[pool.address]['dailyAPR'] + '%') + " Daily ", 1)
                                            ], 64))
                                    ])
                                  ], 64))
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            (!pool?.totalLiquidity)
                              ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                                  key: 0,
                                  class: "w-12"
                                }))
                              : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_unref(fNum2)(pool?.totalLiquidity, {
                    style: 'currency',
                    maximumFractionDigits: 0,
                  })), 1))
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            (!pool?.volumeSnapshot)
                              ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                                  key: 0,
                                  class: "w-12"
                                }))
                              : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString('$' + Math.round(pool?.volumeSnapshot, 2)), 1))
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}


import { defineComponent } from 'vue';

import { BigNumber } from 'ethers';
import {
  BigNumberToString,
  sunriseNameToAddress,
  SPOLAR,
  getDisplayBalance,
} from '@/composables/PolarisFinance/utils';

import {
  spolarABI,
  sunriseABI,
  xpolarRewardPoolABI,
  ERC20ABI,
} from '@/composables/PolarisFinance/ABI';
import { Contract } from 'ethers';

import { sendTransaction } from '@/lib/utils/balancer/web3';
import { MaxUint256 } from '@ethersproject/constants';
import moment from 'moment';

import { rpcProviderService } from '@/services/rpc-provider/rpc-provider.service';
import { accountToAddress, Network } from '@balancer-labs/sdk';
import { Web3Provider } from '@ethersproject/providers';
import useTokensBal from '@/composables/useTokens';
import { getBptBalanceFiatValue } from '@/lib/utils/balancer/pool';
import BigNumberJs from 'bignumber.js';
import usePoolQuery from '@/composables/queries/usePoolQuery';
import usePoolFilters from '@/composables/pools/usePoolFilters';
import useStreamedPoolsQuery from '@/composables/queries/useStreamedPoolsQuery';

import {AprProviderService} from '@/services/pool/apr.provider';

const __default__ = defineComponent({
  data() {
    
    return {
      xpolarPoolQuery: usePoolQuery(
        '0x23a8a6e5d468e7acf4cc00bd575dbecf13bc7f78000100000000000000000015'
      ),
      aprs: {},
      pid: {
        '0x0993fa12d3256e85da64866354ec3532f187e178': 0,
        '0xf0b6cf745afe642c4565165922ad62d6a93857c1': 1,
        '0xd88a378abfe6b6e232525dfb03fbe01ecc863c10': 2,
        '0xa83f9fa9b51fc26e9925a07bc3375617b473e051': 3,
        '0xa215a58225b344cbb62fcf762e8e884dbedfbe58': 4,
        '0x293bbbef6087f681a8110f08bbdedadd13599fc3': 5,
        '0xceecce984f498ee00832670e9ca6d372f6ce155a': 6,
        '0x244caf21eaa7029db9d6b42ddf2d95800a2f5eb5': 7,
        '0x9cd44e44e8a61bc7dc34b04c762a3c0137a3707c': 8,
        '0x454adaa07eec2c432c0df4379a709b1fa4c800ed': 9,
        '0xb3a04902b78fbe61185b766866193630db4db8a3': 10,
        '0x4200333dc021ea5fb1050b8e4f8f3ed7cb1d22ed': 11,
        '0xd8e9e1916a4d98fb0dc6db725a8c8c2af08a329b': 12,
        '0x23a8a6e5d468e7acf4cc00bd575dbecf13bc7f78': 13,
        '0xf0f3b9eee32b1f490a4b8720cf6f005d4ae9ea86': 14,
        '0x3ac55ea8d2082fabda674270cd2367da96092889': 15,
        '0xafe0d6ca6aabb43cda024895d203120831ba0370': 16,
        '0xa69d9ba086d41425f35988613c156db9a88a1a96': 17,
        '0x17cbd9c274e90c537790c51b4015a65cd015497e': 18,
        '0x3a4773e600086a753862621a26a2e3274610da43': 19,
        '0x266437e6c7500a947012f19a3de96a3881a0449e': 20,
        '0x192bdcdd7b95a97ec66de5630a85967f6b79e695': 21,
        '0xce32b28c19c61b19823395730a0c7d91c671e54b': 22,
        '0xfa32616447c51f056db97bc1d0e2d4c0c4d059c9': 23,
        '0x89cc63050ade84bffafd7ec84d24fc0feb5f96c9': 24,
        '0xe370d4d0727d4e9b70db1a2f7d2efd1010ff1d6d': 25,
      },
      prices: this.prices,
      data: this.data,
    };
  },
  methods: {
    async fetchAll() {
      if (this.data.length == 0) {
        await new Promise((resolve, reject) => {
          const loop = () =>
            this.data.length !== 0
              ? resolve(this.data.length)
              : setTimeout(loop, 100);
          loop();
        });
      }

      /*const aprsPromises: any[] = [];
      for (var i = 0; i < this.data.length; i++) {
        aprsPromises.push(this.fetch(this.data[i]));
      }
      const aprs = await Promise.all(aprsPromises);
      for (var i = 0; i < this.data.length; i++) {
        this.aprs[this.data[i].address] = aprs[i];
      }*/
      const aprProviderClass = new AprProviderService(
        this.data,
        this.prices,
        this.xpolarPoolQuery
      );
      aprProviderClass.init();
      aprProviderClass.aprsReceived = (aprs:any)=>{
        this.aprs = aprs;
      }
      aprProviderClass.fetchAll();
    },
    /*async fetch(pool) {
      const w3 = rpcProviderService.getJsonProvider(Network.AURORA);

      const xpolarRewardPoolAddress =
        '0x140e8a21d08CbB530929b012581a7C7e696145eF';
      const xpolarRewardPool = new Contract(
        xpolarRewardPoolAddress,
        xpolarRewardPoolABI,
        w3
      );

      const poolAddress = pool.address;

      const PID = {
        '0x0993fa12d3256e85da64866354ec3532f187e178': 0,
        '0xf0b6cf745afe642c4565165922ad62d6a93857c1': 1,
        '0xd88a378abfe6b6e232525dfb03fbe01ecc863c10': 2,
        '0xa83f9fa9b51fc26e9925a07bc3375617b473e051': 3,
        '0xa215a58225b344cbb62fcf762e8e884dbedfbe58': 4,
        '0x293bbbef6087f681a8110f08bbdedadd13599fc3': 5,
        '0xceecce984f498ee00832670e9ca6d372f6ce155a': 6,
        '0x244caf21eaa7029db9d6b42ddf2d95800a2f5eb5': 7,
        '0x9cd44e44e8a61bc7dc34b04c762a3c0137a3707c': 8,
        '0x454adaa07eec2c432c0df4379a709b1fa4c800ed': 9,
        '0xb3a04902b78fbe61185b766866193630db4db8a3': 10,
        '0x4200333dc021ea5fb1050b8e4f8f3ed7cb1d22ed': 11,
        '0xd8e9e1916a4d98fb0dc6db725a8c8c2af08a329b': 12,
        '0x23a8a6e5d468e7acf4cc00bd575dbecf13bc7f78': 13,
        '0xf0f3b9eee32b1f490a4b8720cf6f005d4ae9ea86': 14,
        '0x3ac55ea8d2082fabda674270cd2367da96092889': 15,
        '0xafe0d6ca6aabb43cda024895d203120831ba0370': 16,
        '0xa69d9ba086d41425f35988613c156db9a88a1a96': 17,
        '0x17cbd9c274e90c537790c51b4015a65cd015497e': 18,
        '0x3a4773e600086a753862621a26a2e3274610da43': 19,
        '0x266437e6c7500a947012f19a3de96a3881a0449e': 20,
        '0x192bdcdd7b95a97ec66de5630a85967f6b79e695': 21,
        '0xce32b28c19c61b19823395730a0c7d91c671e54b': 22,
        '0xfa32616447c51f056db97bc1d0e2d4c0c4d059c9': 23,
        '0x89cc63050ade84bffafd7ec84d24fc0feb5f96c9': 24,
        '0xe370d4d0727d4e9b70db1a2f7d2efd1010ff1d6d': 25,
      };

      if (this.xpolarPoolQuery?.data === undefined) {
        await new Promise((resolve, reject) => {
          const loop = () =>
            this.xpolarPoolQuery?.data !== undefined
              ? resolve(this.xpolarPoolQuery?.data)
              : setTimeout(loop, 100);
          loop();
        });
      }

      if (
        this.prices['0xC42C30aC6Cc15faC9bD938618BcaA1a1FaE8501d'] === undefined
      ) {
        await new Promise((resolve, reject) => {
          const loop = () =>
            this.prices['0xC42C30aC6Cc15faC9bD938618BcaA1a1FaE8501d'] !==
            undefined
              ? resolve(
                  this.prices['0xC42C30aC6Cc15faC9bD938618BcaA1a1FaE8501d']
                )
              : setTimeout(loop, 100);
          loop();
        });
      }

      if (pool.totalLiquidity == '0') {
        await new Promise((resolve, reject) => {
          const loop = () => {
            pool.totalLiquidity != '0'
              ? resolve(pool.totalLiquidity)
              : setTimeout(loop, 100);
            console.log('fetching pool total liquidity');
          };

          loop();
        });
      }
      const poolTotalLiquidty = pool.totalLiquidity;
      const xpolarPool = this.xpolarPoolQuery?.data;

      const xpolarBalance =
        xpolarPool?.onchain?.tokens[
          '0xeaf7665969f1daa3726ceada7c40ab27b3245993'
        ]?.balance;
      const nearBalance =
        xpolarPool?.onchain?.tokens[
          '0x990e50e781004ea75e2ba3a67eb69c0b1cd6e3a6'
        ]?.balance;

      const nearPrice =
        this.prices['0xC42C30aC6Cc15faC9bD938618BcaA1a1FaE8501d']['usd'];

      const xpolarPrice =
        (Number(nearBalance) / Number(xpolarBalance) / (0.2 / 0.4)) *
        Number(nearPrice);

      const pid = PID[poolAddress.toLowerCase()];
      const depositToken = new Contract(poolAddress, ERC20ABI, w3);

      const [xpolarPerSecond, allocPoint, stakedInPoolBigNumber] =
        await Promise.all([
          xpolarRewardPool.xpolarPerSecond(),
          xpolarRewardPool.poolInfo(pid),
          depositToken.balanceOf(xpolarRewardPoolAddress),
        ]);

      const stakedInPool = BigNumberToString(stakedInPoolBigNumber, 14, 4);

      const TVL = new BigNumberJs(poolTotalLiquidty || '')
        .div(pool.totalShares || '')
        .times(stakedInPool)
        .toString();

      const finalXpolarPerSecond = BigNumberToString(
        xpolarPerSecond.mul(allocPoint.allocPoint).div(800000),
        14,
        4
      );
      const tokenPerHour = Number(finalXpolarPerSecond) * 60 * 60;
      const totalRewardPricePerYear = tokenPerHour * 24 * 365 * xpolarPrice;
      const totalRewardPricePerDay = tokenPerHour * 24 * xpolarPrice;

      const dailyAPR = ((totalRewardPricePerDay / Number(TVL)) * 100)
        .toFixed(2)
        .toString();
      const yearlyAPR = ((totalRewardPricePerYear / Number(TVL)) * 100)
        .toFixed(2)
        .toString();

      return { dailyAPR: dailyAPR, yearlyAPR: yearlyAPR };
    },*/
  },
  created() {
    this.fetchAll();
  },
  async mounted() {
    const { selectedTokens } = usePoolFilters();
  },

  watch: {
    async data() {
      // this.fetchAll();
    },
    async prices() {
      // this.fetchAll();
    },
  },
});

export default _defineComponent({
  ...__default__,
  props: {
    data: { type: Array, required: true, default: () => [] },
    isLoading: { type: Boolean, required: false },
    isLoadingMore: { type: Boolean, required: false, default: false },
    showPoolShares: { type: Boolean, required: false, default: false },
    noPoolsLabel: { type: String, required: false, default: 'No pools' },
    isPaginated: { type: Boolean, required: false, default: false },
    selectedTokens: { type: Array, required: false, default: () => [] },
    hiddenColumns: { type: Array, required: false, default: () => [] },
    showBoost: { type: Boolean, required: false, default: false },
    columnStates: { type: Object, required: false, default: () => ({}) },
    title: { type: null, required: true },
    prices: { type: null, required: true, default: [] },
    noApr: { type: Boolean, required: false, default: false },
    img: { type: null, required: true },
    type: { type: null, required: true }
  } as unknown as undefined,
  emits: ['loadMore', 'triggerStake'],
  setup})